export default __webpack_public_path__ + "static/media/kid-8.83409425.jpg";